import React, { useState, useEffect, memo } from "react"
import TextField from "@material-ui/core/TextField"
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete"

const filter = createFilterOptions()

const FreeSoloCreateOptionOnDepartment = memo((props) => {
    const { departments, handleDepartmentChange } = props
    const [value, setValue] = useState(null)

    useEffect(() => {
        if (value && value.departmentId) handleDepartmentChange(value.departmentId)
    }, [value])

    return (
        <>
            <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                        setValue({
                            department: newValue,
                        })
                    } else {
                        setValue(newValue)
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params)
                    return filtered
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="departmentAutoComplete"
                options={departments}
                getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === "string") {
                        return option
                    }
                    // Regular option
                    return option.department
                }}
                renderOption={(option) => option.department}
                freeSolo
                renderInput={(params) => (
                    <TextField fullWidth style={{ marginTop: "15px" }} {...params} label="Search a department" variant="outlined" />
                )}
            />
        </>
    )
})

export default FreeSoloCreateOptionOnDepartment
